document.addEventListener('DOMContentLoaded', function() {

    const loader = document.querySelector('.nf-loader');
    if (loader) {
        window.addEventListener('load', () => {
            loader.classList.add('nf-hidden');
        });
    }

    // Logo Marquee
    const track = document.querySelector('.nf-logos');
    if (track) {
        const logos = Array.from(track.children);

        // Clone the logos to create a seamless scroll
        logos.forEach(logo => {
            const clone = logo.cloneNode(true);
            track.appendChild(clone);
        });

        logos.forEach(logo => {
            const clone2 = logo.cloneNode(true);
            track.appendChild(clone2);
        });
    }

    function initializeSwiper(selector, options) {
        const element = document.querySelector(selector);
        if (element) {
            // Destroy existing Swiper instance if present
            if (element.swiper) {
                element.swiper.destroy(true, true);
            }
            // Initialize new Swiper instance
            return new Swiper(selector, options);
        }
    }

    function setupSwipers() {
        // General Swiper
        initializeSwiper('.swiper', {
            loop: false,
            height: 550,
            slidesPerView: 2,
            slidesPerGroup: 1,
            snapOnRelease: false,
            spaceBetween: 16,
            mousewheel: {
                invert: false
            },
            scrollbar: {
                el: '.swiper-scrollbar',
                draggable: true,
                hide: false
            },
            breakpoints: {
                775: {
                    slidesPerView: 2,
                    slidesPerGroup: 1,
                    spaceBetween: 16,
                },
                800: {
                    slidesPerView: 3,
                    slidesPerGroup: 1,
                    spaceBetween: 16
                },
                1024: {
                    slidesPerView: 4,
                    slidesPerGroup: 1,
                    spaceBetween: 16
                },
            },
        });
    }

    // Initial setup
    setupSwipers();

    // Shopify dynamic section events
    document.addEventListener('shopify:section:load', function(event) {
        setupSwipers();
    });

    document.addEventListener('shopify:section:unload', function(event) {
        const sectionElement = event.target;
        if (sectionElement.querySelector('.swiper')) {
            const swiperInstance = sectionElement.querySelector('.swiper').swiper;
            if (swiperInstance) {
                swiperInstance.destroy(true, true);
            }
        }
    });
    // Product Titles and Text Interaction
    const titleItems = document.querySelectorAll('.nf-product-titles .product-title-item');
    const textItems = document.querySelectorAll('.nf-product-text .product-text-item');
    if (titleItems.length && textItems.length) {
        titleItems.forEach(function(titleItem) {
            titleItem.addEventListener('click', function() {
                const currentActiveTitle = document.querySelector('.nf-product-titles .title-item-active');
                if (currentActiveTitle) {
                    currentActiveTitle.classList.remove('title-item-active');
                }

                titleItem.classList.add('title-item-active');

                const targetId = titleItem.id;
                textItems.forEach(function(textItem) {
                    if (textItem.id === targetId) {
                        textItem.classList.add('text-item-active');
                    } else {
                        textItem.classList.remove('text-item-active');
                    }
                });
            });
        });
    }

    // Announcement Scrolling Bar
    const announcementContent = document.querySelector('.nf-announcement-content');
    if (announcementContent) {
        const contentWidth = announcementContent.scrollWidth;
        const barWidth = announcementContent.parentElement.offsetWidth;

        while (announcementContent.scrollWidth < 2 * barWidth) {
            announcementContent.innerHTML += announcementContent.innerHTML;
        }
    }

    // Mega Menu
    const menuLinks = document.querySelectorAll('.nf-menu-link');
    const megaMenuItems = document.querySelectorAll('.nf-mega-menu-item');
    const header = document.querySelector('.nf-header');

    if (menuLinks.length && megaMenuItems.length) {
        let activeMegaMenuItem = null;
        let activeMenuLink = null;

        menuLinks.forEach(link => {
            link.addEventListener('mouseenter', function() {
                const targetId = link.id;
                const targetMegaMenuItem = document.querySelector(`.nf-mega-menu-item#${targetId}`);

                if (targetMegaMenuItem) {
                    megaMenuItems.forEach(item => item.classList.remove('nf-menu-active'));
                    menuLinks.forEach(item => item.classList.remove('nf-active-menu-item'));

                    targetMegaMenuItem.classList.add('nf-menu-active');
                    activeMegaMenuItem = targetMegaMenuItem;
                    activeMenuLink = targetId;

                    document.querySelector(`.nf-menu-link#${activeMenuLink}`).classList.add('nf-active-menu-item');
                }
            });
        });

        megaMenuItems.forEach(item => {
            item.addEventListener('mouseenter', function() {
                item.classList.add('nf-menu-active');
                activeMegaMenuItem = item;
            });

            item.addEventListener('mouseleave', function() {
                item.classList.remove('nf-menu-active');
                document.querySelector(`.nf-menu-link#${activeMenuLink}`).classList.remove('nf-active-menu-item');
                activeMegaMenuItem = null;
                activeMenuLink = null;
            });
        });

        if (header) {
            header.addEventListener('mouseleave', function() {
                if (!activeMenuLink) {
                    menuLinks.forEach(item => item.classList.remove('nf-active-menu-item'));
                }
                if (!activeMegaMenuItem) {
                    megaMenuItems.forEach(item => item.classList.remove('nf-menu-active'));
                }
            });
        }
    }

    const menuOpener = document.querySelector('#menu-opener'); // Trigger to open the menu
    const menuCloser = document.querySelector('#menu-closer');
    const menuContainer = document.querySelector('.nf-mobile-menu-container');
    const mobileMenu = document.querySelector('.nf-actual-mobile-menu');

    // Open menu
    menuOpener.addEventListener('click', function() {
        menuOpener.classList.toggle('closed');
        menuCloser.classList.toggle('closed');
        menuContainer.classList.toggle('background-on');
    });

    // Open menu
    menuCloser.addEventListener('click', function() {
        menuOpener.classList.toggle('closed');
        menuCloser.classList.toggle('closed');
        menuContainer.classList.toggle('background-on');
    });

    // Close menu when clicking outside the menu
    menuContainer.addEventListener('click', function(e) {
        if (!mobileMenu.contains(e.target)) {
            menuOpener.classList.toggle('closed');
            menuCloser.classList.toggle('closed');
            menuContainer.classList.remove('background-on');
        }
    });

    const menuHeaders = document.querySelectorAll('.nf-mobile-menu-header');

    menuHeaders.forEach(header => {
        header.addEventListener('click', function() {
            // Get the ID of the clicked menu header
            const menuId = header.id;

            // Find the corresponding mobile menu list based on ID
            const correspondingMenuList = document.querySelector(`#menu-${menuId}`);

            // Check if the corresponding menu list exists and toggle the class
            if (correspondingMenuList) {
                header.classList.toggle('header-active');
                correspondingMenuList.classList.toggle('nf-menu-list-open');
            }

            // Optional: Close other open menu lists when one is clicked (if desired)
            // This ensures only one menu is open at a time
            menuHeaders.forEach(otherHeader => {
                if (otherHeader !== header) {
                    const otherMenuId = otherHeader.id;
                    const otherMenuList = document.querySelector(`#mobile-${otherMenuId.split('-')[1]}`);
                    if (otherMenuList) {
                        otherMenuList.classList.remove('nf-menu-list-open');
                    }
                }
            });
        });
    });


    const menuItems = document.querySelectorAll('.nf-mobile-menu-item'); // Select all menu items

    menuItems.forEach(menuItem => {
        const svgWrapper = menuItem.querySelector('.svg-wrapper'); // Find the svg-wrapper within this menu item

        if (svgWrapper) {
            svgWrapper.addEventListener('click', function(event) {
                event.stopPropagation(); // Prevent click events from bubbling if necessary

                const iconImage = svgWrapper.querySelector('img'); // Get the <img> element inside the wrapper
                const currentIcon = svgWrapper.getAttribute('data-icon'); // Get the current icon type (plus or minus)

                // Swap the icon
                if (currentIcon === 'icon-plus') {
                    svgWrapper.setAttribute('data-icon', 'icon-minus');
                    iconImage.src = svgWrapper.getAttribute('data-minus-src'); // Change to minus icon
                } else {
                    svgWrapper.setAttribute('data-icon', 'icon-plus');
                    iconImage.src = svgWrapper.getAttribute('data-plus-src'); // Change to plus icon
                }
            });
        }
    });


    // Function to check screen width and remove the background-on class
    function updateBackgroundClass() {
        const mobileMenuContainer = document.querySelector('.nf-mobile-menu-container');
        if (mobileMenuContainer) {
            if (window.innerWidth >= 1024) {
                mobileMenuContainer.classList.remove('background-on');
                menuOpener.classList.remove('closed');
                menuCloser.classList.add('closed');
            }
        }
    }

    // Check on load
    updateBackgroundClass();

    // Add event listener for window resize
    window.addEventListener('resize', updateBackgroundClass);

});